import React, { ReactElement } from "react"
import styled from "styled-components"
import ToggleButton from "~/components/twilio/ToggleButton"
import AcIcon from "~/components/atoms/AcIcon"

const Toggle = styled.div`
  button,
  button:hover,
  button:focus {
    background-color: #b72519;
    border: #b72519;
  }

  i.phone {
    color: #ffffff;
    transform: rotate(222deg);
  }

  .desc{
    color: #ffffff !important;
  }
`

interface Props {
  className?: string
  onClick?: () => void
}

export default function EndCallButton(props: Props) {
  const { className, onClick } = props

  return (
    <Toggle>
      <ToggleButton className={className} onClick={onClick}>
        <AcIcon name={"phone-flip"} className={"phone"} />
        <p className="desc">終了</p>
      </ToggleButton>
    </Toggle>
  )
}
